import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { EbrCoreModule } from 'src/app/core/components/ebr-core.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { CustomerServiceInsightsComponent } from './customer-service-insights.component';
import { TopBottomLocationsComponent } from './components/top-bottom-locations/top-bottom-locations.component';
import { LocationInsightsDetailsComponent } from './components/location-details/components/location-insights-details/location-insights-details.component';
import { LocationDetailsComponent } from './components/location-details/location-details.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { ServiceInsightsModule } from '../service-insights/service-insights.module';

@NgModule({
  declarations: [
    CustomerServiceInsightsComponent,
    TopBottomLocationsComponent,
    LocationInsightsDetailsComponent,
    LocationDetailsComponent
  ],
  imports: [
    EbrCoreModule,
    SharedModule,
    FormsModule,
    AppRoutingModule,
    CommonModule,
    ServiceInsightsModule,
    MatPaginatorModule,
    MatSelectModule,
  ],
  exports: [

  ]
})

export class CustomerServiceInsightsModule { }
